import { Box } from '@radix-ui/themes'
import { ColorFamilyOption } from '@/types/shared'

interface Props {
  color: ColorFamilyOption
  size?: number
}

// "Multi / livery" has no single hex, so it gets stripes instead of a fill.
const LIVERY = 'repeating-linear-gradient(135deg, #dc2626 0 4px, #facc15 4px 8px, #2563eb 8px 12px)'

export default function ColorSwatch({ color, size = 16 }: Props) {
  return (
    <Box
      aria-hidden
      style={{
        width: size,
        height: size,
        flexShrink: 0,
        borderRadius: '50%',
        border: '1px solid var(--gray-a7)',
        background: color.hex ?? LIVERY,
      }}
    />
  )
}
